import { getAvailableEnemies } from '../constants/progression/EnemyUnlocks';
import { ENEMY_CONFIGS } from '../constants/enemies';

// Особый враг: одна запись = группа из 4 мышей (сохраняем характерный feel),
// стоимость = scoreReward × 4. Если когда-нибудь появятся другие "групповые"
// враги — вынести в EnemyConfig.spawnGroupSize.
export const MOUSE_GROUP_SIZE = 4;

// Структурная пересборка W2: боссы каждые 5, 9 эр по 5 уровней (4 обычных + босс).
// Рост волн 2→3→4 (макс 4). Эта функция вызывается ТОЛЬКО для не-боссовых точек —
// боссовые (5/10/15/20/25/30/35/40/45) обрабатываются через override (LevelConfig).
// Распределение: 1-4 и 6-9 → 2 волны (старт), 11-24 → 3 волны (середина),
// 26-44 → 4 волны (поздняя игра). Заглушка роста, калибровка по ощущению на тесте.
export function getWavesForLevel(level: number): number {
  if (level <= 9) return 2;
  if (level <= 24) return 3;
  return 4;
}

// ЗАГЛУШКА. Калибровка на W11.
export function getWaveBudget(level: number): number {
  return 30 + level * 10;
}

function getEntryCost(enemyId: string): number {
  const base = ENEMY_CONFIGS[enemyId].scoreReward;
  return enemyId === 'mouse' ? base * MOUSE_GROUP_SIZE : base;
}

// Возвращает массив enemyId — кого спавнить в этой волне.
// 'mouse' = группа из 4 при спавне.
export function generateWave(level: number): string[] {
  const available = getAvailableEnemies(level);
  if (available.length === 0) return [];

  let budget = getWaveBudget(level);
  const entries: string[] = [];
  const maxEntries = 50;
  const cheapest = Math.min(...available.map((id) => getEntryCost(id)));

  while (budget >= cheapest && entries.length < maxEntries) {
    const id = available[Math.floor(Math.random() * available.length)];
    const cost = getEntryCost(id);
    if (cost > budget) continue;
    entries.push(id);
    budget -= cost;
  }

  return entries;
}
